import { render, staticRenderFns } from "./AddCouponView.vue?vue&type=template&id=2c545b3b"
import script from "./AddCouponView.vue?vue&type=script&lang=js"
export * from "./AddCouponView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports